<script setup lang="ts">
/**
 * Wrapper local autour de #campaign-ui/CampaignDonorsList.vue.
 * Le composant vit dans le package partagé (source unique). Ce wrapper existe
 * pour que l'auto-import Nuxt (qui ne scanne pas node_modules) trouve le
 * composant sous son nom habituel. Karim 2026-06-21.
 */
import CampaignDonorsList from "@donoor/ui/campaign/CampaignDonorsList.vue";
</script>

<template>
  <CampaignDonorsList v-bind="($attrs as any)" />
</template>
